import React from 'react';
function Move({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 10l-2 2 2 2M10 6l2-2 2 2M14 18l-2 2-2-2M18 10l2 2-2 2M4 12h16M12 4v16"
      />
    </svg>
  );
}

export default Move;
